import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Bot } from 'lucide-react';


const FloatingIcon = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <motion.div
      className="fixed right-8 top-1/2 transform -translate-y-1/2 z-50 hidden md:block" // Oculto en móviles, visible en pantallas medianas y grandes
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 100, damping: 10, delay: 0.5 }}
    >
      <a href="https://wa.me/19795755999?text=Hello!%20I'd%20like%20more%20information%20about%20your%20courses%3A" target="_blank" rel="noopener noreferrer">
        <motion.button
          className="bg-gradient-to-br from-green-500 to-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center"
          whileHover={{ scale: 1.3, rotate: 25, y: -8, boxShadow: "0 0 25px rgba(34, 197, 94, 0.6)" }}
          whileTap={{ scale: 0.9 }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          animate={{
            y: ["0%", "10%", "0%"], // Animación de flotación
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <MessageCircle className="w-8 h-8" />
        </motion.button>
      </a>
      {showTooltip && (
        <div className="absolute right-full mr-3 px-4 py-3 bg-green-600 text-white text-lg font-semibold rounded-full shadow-lg backdrop-blur-sm border-2 border-white/50 whitespace-nowrap flex items-center">
          <Bot className="w-6 h-6 mr-2" />
          I'm Bot-MDX, ​​ask me, I have information for you.
        </div>
      )}
    </motion.div>
  );
};

export default FloatingIcon;